function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as suplierCouponsApi from '@/api/suplierCouponsApi.js';
import { Debounce } from '@/utils/validate';
import SelectCompay from './selectCompay.vue';
export default {
  components: {
    SelectCompay: SelectCompay
  },
  data: function data() {
    return {
      loading: false,
      addresData: [],
      pram: {},
      details: {} // 预留一份数据
    };
  },
  props: {
    editId: [Number, String],
    templateOption: Array
  },
  watch: {
    editId: {
      handler: function handler(editId) {
        if (!editId) {
          this.initParams();
          return;
        }
        ;
        this.getDetail(editId);
      },
      immediate: true
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    initParams: function initParams() {
      this.pram = {};
      this.details = {};
    },
    getDetail: function getDetail(id) {
      var _this = this;
      this.initParams();
      suplierCouponsApi.getSettingDetail(id).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _this.pram = _objectSpread({}, res);
        _this.details = JSON.parse(JSON.stringify(res || {}));
      });
    },
    handerSubmit: Debounce(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this2.loading = true;
        suplierCouponsApi.submitSetting(_objectSpread(_objectSpread({}, _this2.pram), {}, {
          supplierId: _this2.editId
        })).then(function (data) {
          _this2.$message.success('编辑成功');
          _this2.loading = false;
          _this2.$emit('hideDialog');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.$emit('closeEdit');
    },
    selectCompany: function selectCompany(companyId) {
      this.$emit(this.pram, 'initCompany', companyId);
    }
  }
};